import { Injectable, OnDestroy, signal } from '@angular/core';
import { Subscription, interval, switchMap, startWith, catchError, of } from 'rxjs';
import { AdminOrdersApiService } from '../api/admin-orders-api.service';

const POLL_INTERVAL_MS = 30_000; // 30 seconds

@Injectable({ providedIn: 'root' })
export class PendingOrdersService implements OnDestroy {
  readonly count = signal(0);

  private pollSub?: Subscription;

  constructor(private ordersApi: AdminOrdersApiService) {}

  startPolling(): void {
    if (this.pollSub) return;

    this.pollSub = interval(POLL_INTERVAL_MS).pipe(
      startWith(0),
      switchMap(() => this.ordersApi.getPendingReviewCount().pipe(
        catchError(() => of({ count: 0 })),
      )),
    ).subscribe(res => this.count.set(res.count));
  }

  refresh(): void {
    this.ordersApi.getPendingReviewCount().pipe(
      catchError(() => of({ count: 0 })),
    ).subscribe(res => this.count.set(res.count));
  }

  ngOnDestroy(): void {
    this.pollSub?.unsubscribe();
  }
}
